/**
 * src/components/admin/adminHelpers.js
 *
 * Utilidades compartidas del panel admin.
 */

/** Genera un ID único (para elementos nuevos creados en el admin) */
export function nextId(items) {
    return items.length > 0 ? Math.max(...items.map(i => i.id)) + 1 : 1
}

/**
 * Calcula el estado de visibilidad de un negocio:
 * - 'active'    → enabled=true y dentro del rango de fechas (o sin rango)
 * - 'scheduled' → enabled=true pero aún no ha comenzado o ya terminó
 * - 'inactive'  → enabled=false
 */
export function getBusinessStatus(b) {
    if (!b.enabled) return 'inactive'
    const now = new Date()
    if (b.activeFrom && new Date(b.activeFrom) > now) return 'scheduled'
    if (b.activeTo   && new Date(b.activeTo)   < now) return 'scheduled'
    return 'active'
}

/** Etiqueta legible para el estado */
export const STATUS_LABELS = {
    active:    '● Visible',
    inactive:  '● Oculto',
    scheduled: '● Programado'
}

/**
 * Descarga un objeto JS como archivo JSON.
 * @param {Object} data - el objeto a exportar
 * @param {string} filename - nombre del archivo sin extensión
 */
export function downloadJson(data, filename) {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })
    const url  = URL.createObjectURL(blob)
    const a    = document.createElement('a')
    a.href     = url
    a.download = `${filename}.json`
    a.click()
    URL.revokeObjectURL(url)
}

/**
 * Muestra un toast temporal en la esquina inferior derecha.
 * @param {string} msg
 * @param {number} ms - duración en ms (default 2500)
 */
export function showToast(msg, ms = 2500) {
    const t = document.createElement('div')
    t.className = 'adm-toast'
    t.textContent = msg
    document.body.appendChild(t)
    setTimeout(() => t.remove(), ms)
}

/** Formatea una fecha ISO (YYYY-MM-DD) a "dd MMM yyyy" en español */
export function fmtDate(iso) {
    if (!iso) return '—'
    return new Date(iso + 'T00:00:00').toLocaleDateString('es-CO', {
        day: 'numeric', month: 'short', year: 'numeric'
    })
}

/** Convierte fecha ISO a valor para input[type=date] */
export function toInputDate(iso) {
    if (!iso) return ''
    return iso.slice(0, 10)
}
